<template>
	<div class="mainBox">
		<vheader :insti="insti"/>
		<router-view/>
	</div>
</template>
<script>
	import vheader from '@/components/header'
	export default {
		data(){
			return  {
				insti:this.$route.params.insti || JSON.parse(window.localStorage.getItem("insti"))
			}
		},
		components:{
			vheader
		}
	}
</script>



// WEBPACK FOOTER //
// src/views/commonPage/index.vue